<template>
  <v-navigation-drawer fixed app
    id="clientNavigator"
    v-model="config.status.active">
    <v-img :src="getLogo" />
    <ClientEvents :cid="getClientId" />
    <v-list dense class="pt-0">
      <v-list-item v-for="item in authedNavigation"
        :key="item.path"
        :to="item.path"
        active-class="secondary--text secondary lighten-5">
        <v-list-item-avatar class="my-1">
          <v-icon small>{{ item.active ? item.meta.icon.active : item.meta.icon.default }}</v-icon>
        </v-list-item-avatar>
        <v-list-item-content class="body-2">{{ item.meta.label }}</v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import ClientEvents from '@/components/events'
import ClientRoutes from '@/router/client'
export default {
  name: 'ClientNavigator',
  components: { ClientEvents },
  data () {
    return {
      socket: null,
      config: {
        status: {
          loading: false,
          active: true
        },
        logo: require('@/assets/logo_rectangular.svg')
      },
      store: {
        events: []
      }
    }
  },
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    init: function () {
    },
    toggle: function () {
      this.$set(this.config.status, 'active', !this.config.status.active)
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    authedNavigation () {
      let auths = this.$store.getters['author/get']('authority')
      let roles = this.$store.getters['author/get']('roles')
      let matches = this.$route.matched.map(it => it.name)
      return ClientRoutes.routes.filter(rt => {
        return (
          rt.meta &&
          (auths.includes(rt.meta.permit) || roles.includes(rt.meta.permit))
        )
      }).map(rt => {
        return Object.assign({}, rt, {
          active: matches.includes(rt.name),
          path: '/client/' + this.$route.params.id + '/' + rt.path
        })
      })
    },
    getClientId () {
      return this.$route.params.id
    },
    printToday () {
      return this.$moment().format('YYYY年MM月DD日')
    },
    getLogo () {
      return this.config.logo
    },
    getEventItems () {
      return this.store.events.length ? this.store.events.map(it => {
        return {
          id: it.id,
          name: it.summary,
          start: it.start.dateTime ? this.$moment(it.start.dateTime.slice(0, -6).replace('T', ' ')).format('HH:mm') : '',
          end: it.end.dateTime ? this.$moment(it.end.dateTime.slice(0, -6).replace('T', ' ')).format('HH:mm') : '',
          recurringEventId: it.recurringEventId || '',
          color: it.colorId ? this.$mango.google.colors[it.colorId] : ''
        }
      }) : []
    }
  }
}
</script>

<style lang="scss">
#clientNavigator {
  .primary--text {
    background: $mb_c;
    color: $pd_c;
  }
}
</style>
